import { loadImg, roundRect, text, drawBackground, drawBrand, drawAvatar, drawCta, codeFrom } from "@/lib/badgeImage";

const L = {
  story: { W: 1080, H: 1920, logoY: 150, avatarY: 400, r: 110, nameY: 590, monthY: 660, gridY: 760, tile: 300, gap: 40, quoteY: 1460, cardY: 1600, cardH: 250 },
  square: { W: 1080, H: 1080, logoY: 80, avatarY: 210, r: 62, nameY: 325, monthY: 375, gridY: 420, tile: 190, gap: 28, quoteY: 865, cardY: 905, cardH: 150 },
};

export const shortLine = (t = "") => (t.replace(/\*\*/g, "").split(/(?<=[.!?])\s+/)[0] || "").trim().slice(0, 140);

const wrap = (ctx, str, maxW, size) => {
  ctx.font = `600 ${size}px "Plus Jakarta Sans", sans-serif`;
  const lines = [];
  let cur = "";
  for (const w of str.split(" ")) {
    const next = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(next).width > maxW && cur) { lines.push(cur); cur = w; } else cur = next;
  }
  if (cur) lines.push(cur);
  return lines.slice(0, 3);
};

export async function renderMonthImage({ review, user, link, format }) {
  const P = L[format], { W, H } = P, story = format === "story";
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  await document.fonts?.ready;
  const avatar = await loadImg(user.picture, true);
  drawBackground(ctx, W, H);
  await drawBrand(ctx, W, P.logoY, story ? 1.2 : 0.9);
  drawAvatar(ctx, avatar, user.name, W / 2, P.avatarY, P.r);
  text(ctx, user.name, W / 2, P.nameY, { size: story ? 64 : 44, weight: 800, maxW: W - 200, fit: true });
  const month = new Date(`${review.month}-01T12:00:00`).toLocaleDateString("de-DE", { month: "long", year: "numeric" });
  text(ctx, `MEIN ${month.toUpperCase()}`, W / 2, P.monthY, { size: story ? 34 : 24, weight: 800, font: "Plus Jakarta Sans", color: "rgba(255,255,255,0.9)" });

  const s = review.stats || {};
  const tiles = [[s.punkte_gesammelt, "Punkte gesammelt"], [s.beitraege, "Beiträge"], [s.kommentare, "Kommentare"], [s.serie_tage, "Tage-Serie"]];
  const gw = P.tile * 2 + P.gap, x0 = W / 2 - gw / 2;
  tiles.forEach(([v, l], i) => {
    const x = x0 + (i % 2) * (P.tile + P.gap), y = P.gridY + Math.floor(i / 2) * (P.tile + P.gap);
    ctx.save(); ctx.shadowColor = "rgba(131,24,67,0.3)"; ctx.shadowBlur = 40; ctx.shadowOffsetY = 14;
    roundRect(ctx, x, y, P.tile, P.tile, story ? 48 : 32); ctx.fillStyle = "rgba(255,255,255,0.95)"; ctx.fill(); ctx.restore();
    text(ctx, Number(v || 0).toLocaleString("de-DE"), x + P.tile / 2, y + P.tile * 0.55, { size: story ? 104 : 66, weight: 800, color: "#E11D48", maxW: P.tile - 30, fit: true });
    text(ctx, l, x + P.tile / 2, y + P.tile * 0.8, { size: story ? 32 : 22, weight: 700, font: "Plus Jakarta Sans", color: "#6B7280", maxW: P.tile - 24, fit: true });
  });

  const size = story ? 42 : 28;
  const lines = wrap(ctx, `„${shortLine(review.text)}“`, W - 180, size).slice(0, story ? 3 : 1);
  const top = P.quoteY;
  lines.forEach((ln, i) => text(ctx, ln, W / 2, top + i * size * 1.35, { size, weight: 600, font: "Plus Jakarta Sans", maxW: W - 160 }));
  await drawCta(ctx, W, P.cardY, P.cardH, { code: codeFrom(link) });
  return new Promise((resolve) => c.toBlob((b) => resolve(b), "image/png"));
}
